import { PaginationButton } from './pagination-button.component.js';
export { PaginationButton } from './pagination-button.component.js';
import { PaginationEllipses } from './pagination-ellipses.component.js';
export { PaginationEllipses } from './pagination-ellipses.component.js';
import { PaginationInput } from './pagination-input.component.js';
export { PaginationInput } from './pagination-input.component.js';
import { PaginationLabel } from './pagination-label.component.js';
export { PaginationLabel } from './pagination-label.component.js';
import { PaginationStep } from './pagination-step.component.js';
export { PaginationStep } from './pagination-step.component.js';
import { Pagination } from './pagination.component.js';
export { Pagination } from './pagination.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
/* PLOP_COMPONENT_EXPORT_IN_INDEX */
// Please don't remove the above Plop token

/**
 * @deprecated Use <PaginationButton> instead
 */

var PaginatorButton = deprecatedComponent({
  displayName: 'PaginatorButton',
  root: PaginationButton,
  description: 'Use PaginationButton component Instead'
});
/**
 * @deprecated Use <PaginationEllipses> instead
 */

var PaginatorEllipses = deprecatedComponent({
  displayName: 'PaginatorEllipses',
  root: PaginationEllipses,
  description: 'Use PaginationEllipses component Instead'
});
/**
 * @deprecated Use <PaginationInput> instead
 */

var PaginatorInput = deprecatedComponent({
  displayName: 'PaginatorInput',
  root: PaginationInput,
  description: 'Use PaginationInput component Instead'
});
/**
 * @deprecated Use <PaginationLabel> instead
 */

var PaginatorLabel = deprecatedComponent({
  displayName: 'PaginatorLabel',
  root: PaginationLabel,
  description: 'Use PaginationLabel component Instead'
});
/**
 * @deprecated Use <PaginationStep> instead
 */

var PaginatorStep = deprecatedComponent({
  displayName: 'PaginatorStep',
  root: PaginationStep,
  description: 'Use PaginationStep component Instead'
});
/**
 * @deprecated Use <Pagination> instead
 */

var Paginator = deprecatedComponent({
  displayName: 'Paginator',
  root: Pagination,
  description: 'Use Pagination component Instead'
});
export { Paginator, PaginatorButton, PaginatorEllipses, PaginatorInput, PaginatorLabel, PaginatorStep };